<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { initialsFromEmail } from '@client/utils/users';

  import { generateUUID } from '@common/utils/strings';

  export let data = {};

  // One stable id per component instance; per-avatar ids derive from it + index
  // so they don't change across re-renders (sveltestrap caches the tooltip target).
  const instanceId = generateUUID();

  $: excludedTag = $format('label.EXCLUDED_TAG');
  // Rank the dynamic-membership indicator first so it is always within the
  // visible (non-overflow) slice; then included before excluded, then by name.
  $: senders = data.senders.sort((a, b) => {
    if (!!a.dynamic !== !!b.dynamic) return a.dynamic ? -1 : 1;
    if (!!a.excluded !== !!b.excluded) return a.excluded ? 1 : -1;
    return a.username.localeCompare(b.username);
  });
</script>

<div class="assigned-users" class:single={senders.length === 1}>
  <ul>
    {#each senders.slice(0, 6) as user, index}
      {@const id = `${instanceId}-${index}`}

      {#if index <= Math.min(4, senders.length - 1)}
        <li {id} class:all={user.username === '*'} class:excluded={user.excluded}>
          {#if user.dynamic}
            <Icon name="filter" />
            <Tooltip target={id} placement="top">
              {$format('label.DYNAMIC_MEMBERSHIP')}
            </Tooltip>
          {:else if user.username === '*'}
            <span>{$format('label.ALL')}</span>
            <Tooltip target={id} placement="top">
              {$format('label.ENTIRE_COMPANY')}
            </Tooltip>
          {:else}
            <span>
              {initialsFromEmail(`${user.username}@`)}
            </span>
            <Tooltip target={id} placement="top">
              {user.username}{#if user.excluded}
                - {excludedTag}{/if}
            </Tooltip>
          {/if}
        </li>
      {:else}
        <li class="more" id="{id}-more">
          <span>+{senders.length - index}</span>
          <Tooltip target="{id}-more" placement="top">
            {@html senders
              .map((sender) => `${sender.username}${sender.excluded ? ` - ${excludedTag}` : ''}`)
              .slice(index)
              .join('<br>')}
          </Tooltip>
        </li>
      {/if}
    {/each}
  </ul>
</div>

<style lang="scss" src="./portholes.scss"></style>
